import React from "react";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
// Different Brands.
import AcademyLoginAside from "./AcademyLoginAside";
import DefaultLoginAside from "./DefaultLoginAside";
import DefaultSignupAside from "./DefaultSignupAside";
import PostCheckoutLoginAside from "./PostCheckoutLoginAside";
import ActivateAside from "../ActivateAside";
import BFLoginAside from "./BFLoginAside";
import { isBlackFridayActive } from "../../config/blackFridayConfig";

/**
 * A card representing a message in a login screen,
 * e.g. "Welcome back!", "Password changed".
 *
 * @param  {object} props The props.
 *
 * @returns {ReactElement} The component that contains the message.
 */
function LoginMessage( props ) {
	const { asideType } = props;

	/**
	 * Switch between different brands.
	 *
	 * @param  {string} asideTypeString The aside type used to make a selection.
	 *
	 * @returns {ReactElement} The component with the corresponding brand.
	 */
	function selectAside( asideTypeString ) {
		let asideComponent;

		switch ( asideTypeString ) {
			case "academy" :
				asideComponent = <AcademyLoginAside />;
				break;
			case "post-checkout":
				asideComponent = <PostCheckoutLoginAside />;
				break;
			case  "signup" :
				asideComponent = <DefaultSignupAside />;
				break;
			case  "login" :
				asideComponent = <DefaultLoginAside />;
				break;
			case  "activate" :
				asideComponent = <ActivateAside />;
				break;
			default:
				asideComponent = <DefaultSignupAside />;
		}

		// Append Black Friday promo below the standard aside during BF period
		if ( isBlackFridayActive() ) {
			return (
				<>
					{ asideComponent }
					<BFLoginAside />
				</>
			);
		}

		return asideComponent;
	}

	return selectAside( asideType );
}

LoginMessage.propTypes = {
	asideType: PropTypes.string,
};

LoginMessage.defaultProps = {
	asideType: "signup",
};

export default injectIntl( LoginMessage );
